export default __webpack_public_path__ + "banner2fa4d83.png";